var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 110,
    viewBox: "0 0 216 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3648 77.8925C16.4211 73.3383 10.9972 68.4365 7.47088 63.3163C38.8257 25.0728 68.2793 9.46644 104.713 6.74984C140.165 4.10647 166.978 19.9931 207.928 62.9527C178.322 89.0152 138.022 104.063 110.91 103.827C96.6494 103.702 73.6581 99.5913 52.3044 91.8525C41.6632 87.996 31.6172 83.3051 23.3648 77.8925Z",
    stroke: "black",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightEye);
export default __webpack_public_path__ + "static/media/right_eye.482b9d01a9729195f2265652f066be3a.svg";
export { ForwardRef as ReactComponent };